<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";

/**
 * Starter component
 */
export default {
  page: {
    title: "Servis",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      phaseOneShow: false,
      dateLastService: "",
      tData: {
        fleetType: [
          {
            manufactur: "Suzuki - New Carry",
            vehicleCategory: "Pickup",
            vehicleType: "Fleet Deck STD",
          },
          {
            manufactur: "Suzuki - New Carry",
            vehicleCategory: "Pickup",
            vehicleType: "Fleet Deck STD",
          },
        ],
        addFleetModal: [],
        infoBuyer: [
          {
            price: "Rp 100.000",
            date: "28 Apr 2022",
            reference: "MO-159",
            note: "Pembelian Vendor A"
          }
        ]
      },
      selected: {
        fleetType: [],
        addFleetModal: [],
        infoBuyer: []
      },
      selectedModel: {
        fleetType: [],
        addFleetModal: [],
        infoBuyer: []
      },
      allSelected: {
        fleetType: false,
        addFleetModal: false,
        infoBuyer: false
      },
      indeterminate: {
        fleetType: true,
        addFleetModal: true,
        infoBuyer: true
      },
      brand: null,
      partsType: null,
      quality: null,
      serviceCat: null,
      locationTypeService: null,
      serviceLoc: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
    };
  },

  computed: {
    /**
     * Total no. of records
     */

    title() {
      return "Ubah Suku Cadang";
    },

    items() {
      return [
        {
          text: "Data Master",
          to: "/master/",
        },
        {
          text: "Pemeliharaan Kendaraan",
          href: "/master/service/",
        },
        {
          text: "SC - 980",
          active: true,
        },
      ];
    },

    fleetType() {
      return [
        {
          key: "columnCheck",
          thClass: "mc-table--30",
          sortable: false,
        },
        {
          key: "manufactur",
          label: "Manufaktur",
          sortable: true,
        },
        {
          key: "vehicleCategory",
          label: "Kategori Kendaraan",
          sortable: true,
        },
        {
          key: "vehicleType",
          label: "Jenis Kendaraan",
          sortable: true,
        },
      ];
    },

    addFleetModal() {
      return [
        {
          key: "columnCheck",
          thClass: "mc-table--30",
          sortable: false,
        },
        {
          key: "manufactur",
          label: "Manufaktur",
          sortable: true,
        },
        {
          key: "vehicleCategory",
          label: "Kategori Kendaraan",
          sortable: true,
        },
        {
          key: "vehicleType",
          label: "Jenis Kendaraan",
          sortable: true,
        },
      ];
    },

    infoBuyer() {
      return [
        {
          key: "price",
          label: "Harga Beli",
          sortable: true,
        },
        {
          key: "date",
          label: "Tanggal Beli",
          sortable: true,
        },
        {
          key: "reference",
          label: "Referensi Perintah Servis",
          sortable: true,
        },
        {
          key: "note",
          label: "Keterangan",
          sortable: true,
        },
      ];
    },
  },

  methods: {
    /**
     * Search the table data with search input
     */

    rows() {
      return this.tData.addFleetModal.length;
    },

    totalTrue() {
      return this.selectedModel.addFleetModal.filter((c) => c === true);
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = [];
      this.selected[param] = [];
      if (checked) {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selected[param].push(i);
          this.selectedModel[param].push(true);
        }
      } else {
        for (let i = 0; i < this.tData[param].length; i++) {
          this.selectedModel[param].push(false);
        }
        this.selected[param] = [];
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.index);
      } else {
        var myIndex = this.selected[param].indexOf(data.index);
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1);
        }
      }
    },

    toDelete(param) {
      this.selected[param].sort();
      this.selected[param].reverse();
      this.selected[param].forEach((row) => {
        this.$delete(this.tData[param], row);
      });
      this.selected[param] = [];
      this.selectedModel[param] = [];

      this.indeterminate[param] = false;
      this.allSelected[param] = false;
      for (let i = 0; i < this.tData[param].length; i++) {
        this.selectedModel[param].push(false);
      }

      // Promise.all(promises).then(() => {
      //   this.clearCheck();
      //   this.$bvModal.hide("modal-delete");
      // });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button variant="outline-primary" class="me-2" v-b-modal.infoBuyer>
            <i class="mc-fa icon-outline_info"></i>
            Informasi Pembelian
          </b-button>
          <b-button variant="outline-primary" @click="$router.go(-1)">
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
          <b-button variant="primary" class="ms-2">
            <i class="mc-fa icon-outline_save"></i> {{ $t("global.save") }}
          </b-button>
        </div>
      </div>
      <div class="row my-5">
        <div class="col-md-10">
          <div class="mc-list-info__top">
            <div>
              <span class="d-block">Kode Suku Cadang</span>
              <strong>SC - 245</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form ref="form">
      <h4 class="card-title">Informasi Suku Cadang</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group
              label="Nama Suku Cadang"
              label-for="name"
              label-class="required"
            >
              <b-input-group>
                <b-form-input
                  id="name"
                  trim
                  placeholder="Nama Suku Cadang"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <label class="required">Jenis Suku Cadang</label>
            <multiselect
              v-model="partsType"
              :options="['Type 1', 'Type 2']"
              placeholder="Jenis Suku Cadang"
            >
            </multiselect>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <label class="required">Merk</label>
            <multiselect
              v-model="brand"
              :options="['Brand 1', 'Brand 2']"
              placeholder="Merk"
            >
            </multiselect>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group label="SKU" label-for="sku">
              <b-input-group>
                <b-form-input id="sku" trim placeholder="SKU"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <label>Kualitas</label>
            <multiselect
              v-model="quality"
              :options="['Kualitas 1', 'Kualitas 2']"
              placeholder="Kualitas"
            >
            </multiselect>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group label="Deskripsi" label-for="description">
              <b-input-group>
                <b-form-input
                  id="description"
                  trim
                  placeholder="Deskripsi"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <div class="clearfix mb-3">
        <div class="float-start">
          <h4 class="card-title">Jenis Kendaraan</h4>
        </div>

        <div class="float-end">
          <div class="text-end mc-list-header">
            <b-button
              v-if="selected.fleetType.length"
              v-b-modal.modal-delete
              variant="outline-danger"
              class="ms-2"
            >
              <i class="mc-fa icon-outline_trash"></i> {{ $t("global.delete") }}
            </b-button>
            <b-button variant="primary" class="ms-2" v-b-modal.addFleetModal>
              <i class="mc-fa icon-outline_plus"></i>
              {{ $t("global.addField") }}
            </b-button>
          </div>
        </div>
      </div>
      <b-card>
        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="fleetType"
            :items="tData.fleetType"
            class="datatables"
            responsive="sm"
            sort-by="grubService"
            empty-table
            :empty-text="$t('global.emptyTable')"
          >
            <template #head(columnCheck)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'fleetType')"
                  v-model="allSelected.fleetType"
                  :indeterminate="indeterminate.fleetType"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(columnCheck)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data, 'fleetType')"
                  v-model="selectedModel.fleetType[data.index]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(grubService)="data">
              <a v-b-modal.changeData>
                <strong class="text-primary">
                  {{ data.item.grubService }}
                </strong>
              </a>
            </template>
          </b-table>
        </div>
      </b-card>
    </form>

    <b-modal
      class="mc-modal"
      id="addFleetModal"
      ref="addFleetModal"
      title="Tambah Kendaraan"
      header-bg-variant="primary"
      header-close-variant="light"
      ok-title="Simpan"
      cancel-title="Batal"
      cancel-variant="outline-primary"
      size="lg"
      centered
    >
      <b-row class="mb-3">
        <b-col sm="12" md="6" class="mb-3">
          <label class="required">Manufaktur</label>
          <multiselect
            v-model="partsType"
            :options="['Type 1', 'Type 2']"
            placeholder="Manufaktur"
            :multiple="true"
          >
          </multiselect>
        </b-col>
        <b-col sm="12" md="6" class="mb-3">
          <label class="required">Jenis Kendaraan</label>
          <multiselect
            v-model="brand"
            :options="['Brand 1', 'Brand 2']"
            placeholder="Jenis Kendaraan"
            :multiple="true"
          >
          </multiselect>
        </b-col>
      </b-row>
      <div>
        <div class="clearfix">
          <div class="float-start">
            <h6 v-if="totalTrue.length" class="mc-row-check">
              <span class="badge btn-success">{{ totalTrue.length }}</span>
              Baris terpilih.
              <a class="color-primary" @click="clearCheck">Bersihkan semua</a>
            </h6>
          </div>

          <!-- Search -->
          <div class="float-end">
            <div class="mc-table-view">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
                <label
                  class="
                    d-inline-flex
                    align-items-center
                    mc-table-view__search
                  "
                >
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="addFleetModal"
            :items="tData.addFleetModal"
            class="datatables"
            responsive="sm"
            sort-by="manufactur"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #head(columnCheck)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'applicationFleet')"
                  v-model="allSelected.applicationFleet"
                  :indeterminate="indeterminate.applicationFleet"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(columnCheck)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data, 'applicationFleet')"
                  v-model="selectedModel.applicationFleet[data.index]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="mc-modal"
      id="infoBuyer"
      ref="infoBuyer"
      title="Informasi Pembelian"
      header-bg-variant="primary"
      header-close-variant="light"
      size="lg"
      centered
      no-footer
      hide-footer="true"
    >
      <div>
        <div class="clearfix">
          <!-- Search -->
          <div class="float-end">
            <div class="mc-table-view">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
                <label
                  class="
                    d-inline-flex
                    align-items-center
                    mc-table-view__search
                  "
                >
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="infoBuyer"
            :items="tData.infoBuyer"
            class="datatables"
            responsive="sm"
            sort-by="price"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
          </b-table>
        </div>
        <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("global.show") }}
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    entri
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
      </div>
    </b-modal>
  </Layout>
</template>